"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noop = void 0;
/**
 * Empty (no operation) function.
 */
// eslint-disable-next-line @typescript-eslint/no-empty-function
var noop = function () { };
exports.noop = noop;
//# sourceMappingURL=noop.js.map